import React from 'react';
import PropTypes from 'prop-types';

const SubcompanyDelete = ({ subcompany, canDelete, handleDelete }) => {
  return canDelete ? (
    <button
      className="close delete"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        handleDelete(subcompany);
      }}
    >
      <i className="fa fa-times-circle" />
    </button>
  ) : null;
};

SubcompanyDelete.propTypes = {
  canDelete: PropTypes.bool.isRequired,
};

export default SubcompanyDelete;



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/components/SubcompanyDelete.js